// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1692f38e","239":"c02a5946","453":"adf296bd","455":"c4705bd5"}[chunkId] + ".chunk.js";
};